import {routes, request} from "./"

export function fetchPages (commit) {
    return request(commit, routes.pages.fetch, false)
}

export function createPage (commit, page) {
    return request(commit, routes.pages.create, page, 'post')
}

export function updatePage (commit, page) {
    return request(commit, routes.pages.update, page, 'post')
}

export function sortPage (commit, page) {
    return request(commit, routes.pages.sort, page, 'post')
}

export function deletePage (commit, page) {
    return request(commit, routes.pages.delete, page, 'post')
}

export function createPageContent (commit, pageContent) {
    return request(commit, routes.pages.createContent, pageContent, 'post')
}

export function updatePageContent (commit, pageContent) {
    return request(commit, routes.pages.updateContent, pageContent, 'post')
}

export function sortPageContent (commit, pageContent) {
    return request(commit, routes.pages.sortContent, pageContent, 'post')
}

export function deletePageContent (commit, pageContent) {
    return request(commit, routes.pages.deleteContent, pageContent, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/pages.js
// module id = 609
// module chunks = 0